import React from 'react';
export function HookSection() {
  return <section className="py-12 px-4 bg-dark" data-id="element-142">
      <div className="max-w-[680px] mx-auto text-center space-y-[12px] text-base text-body leading-[1.5]" data-id="element-143">
        <p data-id="element-144">
          Te levantas. Ya estás cansado. No es el sueño. No es el trabajo. Es
          algo más profundo que no puedes nombrar.
        </p>

        <p data-id="element-145">
          Por dentro hay un ruido que no para — y{' '}
          <span className="text-white font-medium" data-id="element-146">
            nadie te enseñó a apagarlo.
          </span>
        </p>

        <p className="text-xl md:text-2xl font-serif text-gold mt-6 font-bold leading-[1.4]" data-id="element-147">
          Esto no es debilidad.
          <br data-id="element-148" />
          Es que tu mente necesita un Reset.
        </p>
      </div>
    </section>;
}